import { useSelector } from "react-redux";

export const useSummary = () => {
    return useSelector((state) => state.summary);
};
